import { render, staticRenderFns } from "./logo-anim-phrase.vue?vue&type=template&id=3da98fe5&scoped=true&"
import script from "./logo-anim-phrase.vue?vue&type=script&lang=js&"
export * from "./logo-anim-phrase.vue?vue&type=script&lang=js&"
import style0 from "./logo-anim-phrase.vue?vue&type=style&index=0&id=3da98fe5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da98fe5",
  null
  
)

export default component.exports